// import sailsiojs from '../../libs/sailsjs/sails.io'

/*
help: https://www.npmjs.com/package/vue-sails.io
или https://github.com/kristofvandam/vue-sails.io
The sails object is mapped to 'this.$sails'
The following functions are exposed:
this.$sails.addListener(socket, mutation)
this.$sails.removeListener(socket)
this.$sails.hasListener(socket)
this.$sails.socket.get(url, data) // or post, delete, put
this.$sails.socket.on(url, function(data) {})
*/

// import Vue from 'Vue'

import arrayTools from '@/technical/arrayTools/arrayTools'

import mainCommonDataLoader from '../components/mainCommonDataLoader'
import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import serverData from '@/store/serverData'

export default function (theComponent, cb) {
  var sailsIO = theComponent.$sails
  var appSettings = theComponent.appSettings

  var serverUrl = appSettings.server.host

  // сначала подготавливаем листенера
  sailsIO.socket.on('connect', function onConnect () {
    console.log('>>>>>>> sailsWebsocket connected to server ' + sailsIO.sails.url)
    // console.log('>>>>>>> mainCommonDataLoader starts')
    // вся перезагрузка commonData должна производится при любом ре-коннекте сокета чтобы не потерять данные которые обновлялись пока не было связи
    theComponent.commonDataIsLoadedSet(false)
    mainCommonDataLoader({all: true}, function (error) {
      if (error) {
        console.log('>>>>>>> mainCommonDataLoader finished with ERROR: ' + error)
        serverErrorHandling(error, theComponent)
        cb(error)
      } else {
        // console.log('>>>>>>> mainCommonDataLoader finished')
        theComponent.commonDataIsLoadedSet(true)
        cb()
      }
    })
  })

  // преобразуем http://localhost:1777/api/ в http://localhost:1777 чтобы sails socket достучался
  sailsIO.sails.url = serverUrl.substr(0, serverUrl.substr(0, serverUrl.lastIndexOf('/')).lastIndexOf('/')) + '/'
  // и коннектимся вот такой строкой. но ща это и автоматом работает
  // var mySocket = sailsIO.sails.connect()

  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  // help: https://sailsjs.com/documentation/concepts/realtime
  //       https://sailsjs.com/documentation/reference/web-sockets
  // подписываться на любую модель надо: 1. on model 2. get all models
  // без второго пункта не подписываешься на новые модели (да и на старые тоже, хотя в доках анписано что сработает для старых)
  // (????????????? кстати вопрос: а если на сервере в коде где-то сделать model.create/update/delete - этот объект автоматом тоже
  // уйдет клиенту или это руками посылать на сервере - надо проверить ???????????????)
  // !!! минус: надо все объекты модели отправить и получить просто для того чтобы подписаться. уменьшение списка способом
  // типа user?where={lala:lala} не помогает - подписка не срабатывает
  // ВЫВОД: надо делать rooms по одной на одну модель (userModelRoom), подписываться на нее со стороны клиента и на серевере pub делать при CRUD
  // или какую-то одну комнату standardPOSXCommonDataPublishingRoom и на сервере рассылать не тем кто в комнатах моделей а тем кто подписался на все (хуже этот вариант?)
  /*
  sailsIO.socket.on('task', function (data) {
    console.log('>>>>>>>> on task: received:', data)
  })
  sailsIO.socket.get('/api/task', function (data) {
    console.log('>>>>>>>> get /tasks: received:', data)
  })
  */

  /*
  sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'financeBoxes'}, function (data, jwRes) {
    if (jwRes.statusCode === 200) console.log('>>>>>>>> Suscribed to Model`s Notifier of financeBoxes.')
    else console.error('>>>>>>>> Suscribing to Model`s Notifier of financeBoxes return ERROR: ', data)
  })
  sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'financeOperations'}, function (data, jwRes) {
    if (jwRes.statusCode === 200) console.log('>>>>>>>> Suscribed to Model`s Notifier of financeOperations.')
    else console.error('>>>>>>>> Suscribing to Model`s Notifier of financeOperations return ERROR: ', data)
  })
  sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'systemDocs'}, function (data, jwRes) {
    if (jwRes.statusCode === 200) console.log('>>>>>>>> Suscribed to Model`s Notifier of systemDocs.')
    else console.error('>>>>>>>> Suscribing to Model`s Notifier of systemDocs return ERROR: ', data)
  })
  sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'goods'}, function (data, jwRes) {
    if (jwRes.statusCode === 200) console.log('>>>>>>>> Suscribed to Model`s Notifier of goods.')
    else console.error('>>>>>>>> Suscribing to Model`s Notifier of goods return ERROR: ', data)
  })
  */
  // !!!!! чтобы подисаться на news надо перенести их в serverData
  /* sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'news'}, function (data, jwRes) {
    if (jwRes.statusCode === 200) console.log('>>>>>>>> Suscribed to Model`s Notifier of news.')
    else console.error('>>>>>>>> Suscribing to Model`s Notifier of news return ERROR: ', data)
  }) */
  sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'tasks'}, function (data, jwRes) {
    if (jwRes.statusCode === 200) console.log('>>>>>>>> Suscribed to Model`s Notifier of tasks.')
    else console.error('>>>>>>>> Suscribing to Model`s Notifier of tasks return ERROR: ', data)
  })
  sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'partners'}, function (data, jwRes) {
    if (jwRes.statusCode === 200) console.log('>>>>>>>> Suscribed to Model`s Notifier of partners.')
    else console.error('>>>>>>>> Suscribing to Model`s Notifier of partners return ERROR: ', data)
  })
  sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'finixBanks'}, function (data, jwRes) {
    if (jwRes.statusCode === 200) console.log('>>>>>>>> Suscribed to Model`s Notifier of finixBanks.')
    else console.error('>>>>>>>> Suscribing to Model`s Notifier of finixBanks return ERROR: ', data)
  })

  // ///////////////////////////////////////////////////////////////////////////////////////////////

  function handleData (dataName, resourceUrl, data) {
    switch (data.method) {
      case 'create':
        let item = restResource(resourceUrl)
        item.val = Object.assign({}, data.record)
        serverData[dataName].push(item)
        serverData.eventsBus.$emit(dataName + 'Changed', data)
        break
      case 'update':
        let itemNum = arrayTools.findItemNum(serverData[dataName], data.record.id)
        if (itemNum != null) {
          serverData[dataName][itemNum].val = Object.assign(serverData[dataName][itemNum].val, data.record) // не меняя объект перетираем значения
        } else { // делаем как будто новый create
          let item = restResource(resourceUrl)
          item.val = Object.assign({}, data.record)
          serverData[dataName].push(item)
        }
        serverData.eventsBus.$emit(dataName + 'Changed', data)
        break
      case 'destroy':
        itemNum = arrayTools.findItemNum(serverData[dataName], data.record.id)
        if (itemNum != null) serverData[dataName].splice(itemNum, 1)
        serverData[dataName + 'OnDestroy'](data.record, function (err) {  // =financeOperationsOnDestroy like
          if (err) return console.log('ERRRRROR123')
          serverData.eventsBus.$emit(dataName + 'Changed', data)
          return
        })
        break
    }
  }

  // ///////////////////////////////////////////////////////////////////////////////////////////////

  // !!!!!!!!! Через сокет при UPDATE данные в val.value приходят как string. Поэтому их надо JSON.parse !!! В отличие от простого html get request, где все приходит как JSON !!!
  function handleDataWithValValue (dataName, resourceUrl, data, valField) {
    switch (data.method) {
      case 'create':
        let item = restResource(resourceUrl)
        item.val = Object.assign({}, data.record)
        item.val[valField] = Object.assign({}, data.record[valField])
        serverData[dataName].push(item)
        serverData.eventsBus.$emit(dataName + 'Changed', data)
        break
      case 'update':
        let itemNum = arrayTools.findItemNum(serverData[dataName], data.record.id)
        if (itemNum != null) {
          serverData[dataName][itemNum].val = Object.assign(serverData[dataName][itemNum].val, data.record) // не меняя объект перетираем значения
          // serverData[dataName][itemNum].val.value = Object.assign(serverData[dataName][itemNum].val.value, data.record.value) // не меняя объект перетираем значения
          serverData[dataName][itemNum].val[valField] = JSON.parse(data.record[valField]) // не меняя объект перетираем значения
        } else { // делаем как будто новый create
          let item = restResource(resourceUrl)
          item.val = Object.assign({}, data.record)
          item.val[valField] = Object.assign({}, JSON.parse(data.record[valField]))
          serverData[dataName].push(item)
        }
        serverData.eventsBus.$emit(dataName + 'Changed', data)
        break
      case 'destroy':
        itemNum = arrayTools.findItemNum(serverData[dataName], data.record.id)
        if (itemNum != null) serverData[dataName].splice(itemNum, 1)
        serverData[dataName + 'OnDestroy'](data.record, function (err) {  // =financeOperationsOnDestroy like
          if (err) return console.log('ERRRRROR123')
          serverData.eventsBus.$emit(dataName + 'Changed', data)
          return
        })
        break
    }
  }

  // ///////////////////////////////////////////////////////////////////////////////////////////////

  sailsIO.socket.on('financeoperation', function (data) {
    // console.log('>>>>>>>> On financeoperation. Received:', data)
    // console.log(theComponent.commonData.financeOperations)
    handleData('financeOperations', theComponent.appSettings.server.host + theComponent.appSettings.server.financeOperationResource, data)
  })

  // ///////////////////////////////////////////////////////////////////////////////////////////////

  sailsIO.socket.on('financebox', function (data) {
    // console.log('>>>>>>>> On financebox. Received:', data)
    mainCommonDataLoader({financeBoxes: true}, function (error) { // !!!!!!!!!!!!!!!!!!!! это ошибочный запрос. измененый financebox уже пришел его просто надо в serverdata, а не запрашивать еще раз
      if (error !== null) {
        theComponent.commonDataIsLoadedSet(false) // чтобы если будет ошибка не отображать неверные полуданные, лучше видеть проблему и решать, а пользователь F5
        return serverErrorHandling(error, theComponent)
      } else {
        theComponent.commonDataIsLoadedSet(true)
      }
    })
  })

  // ///////////////////////////////////////////////////////////////////////////////////////////////

  sailsIO.socket.on('systemdoc', function (data) {
    // console.log('>>>>>>>> On systemdoc. Received:', data)
    // console.log(typeof data.record.value)
    // console.log(data.record.value)
    // console.log(theComponent.commonData.financeOperations)
    if (data.record == null) return serverErrorHandling('От сервера пришел ошибочный systemDoc, теперь данные не верны!', theComponent)
    switch (data.record.type) {
      case 1: // inkassi
        handleDataWithValValue('financeInkassi', theComponent.appSettings.server.host + theComponent.appSettings.server.systemDocResource, data, 'value')
        break
      case 2: // cashboxDailyReports
        handleDataWithValValue('financeCashboxDailyReports', theComponent.appSettings.server.host + theComponent.appSettings.server.systemDocResource, data, 'value')
        break
      case 3: // financeShopRefunds
        handleDataWithValValue('financeShopRefunds', theComponent.appSettings.server.host + theComponent.appSettings.server.systemDocResource, data, 'value')
        break
      case 4: // goodsDefects
        handleDataWithValValue('goodsDefects', theComponent.appSettings.server.host + theComponent.appSettings.server.systemDocResource, data, 'value')
        break
    }
  })

  // ///////////////////////////////////////////////////////////////////////////////////////////////

  sailsIO.socket.on('good', function (data) {
    // console.log('>>>>>>>> On good. Received:', data)
    handleData('goods', theComponent.appSettings.server.host + theComponent.appSettings.server.goodResource, data)
  })

  // ///////////////////////////////////////////////////////////////////////////////////////////////

  // !!!!! чтобы подисаться на news надо перенести их в serverData
  /* sailsIO.socket.on('news', function (data) {
    // console.log('>>>>>>>> On tasks. Received:', data)
    handleData('news', theComponent.appSettings.server.host + theComponent.appSettings.server.taskResource, data)
  }) */

  sailsIO.socket.on('task', function (data) {
    // console.log('>>>>>>>> On tasks. Received:', data)
    handleDataWithValValue('tasks', theComponent.appSettings.server.host + theComponent.appSettings.server.taskResource, data, 'body')
  })

  sailsIO.socket.on('partner', function (data) {
    console.log('>>>>>>>> On partners. Received:', data)
    handleDataWithValValue('partners', theComponent.appSettings.server.host + theComponent.appSettings.server.partnerResource, data, 'body')
  })

  sailsIO.socket.on('finixBank', function (data) {
    console.log('>>>>>>>> On finixBanks. Received:', data)
    handleDataWithValValue('finixBanks', theComponent.appSettings.server.host + theComponent.appSettings.server.finixBankResource, data, 'body')
  })

  // ///////////////////////////////////////////////////////////////////////////////////////////////

  /*
  пример как выглядело бы преоразование полученного объекта, если бы подписку делали через sails pubsub:
    sailsIO.socket.get('/api/partner', function (data) {
      console.log('>>>>>>>> subscribe and get /api/partner: received:', data)
    })
  тогда приходящий объект имеет поля verb и data. преобразовываем и отдаем в handleData
  */
  /*
  sailsIO.socket.on('partner', function (data) {
    console.log('>>>>>>>> On Partners. Received:', data)
    if (data.verb != null) {
      var method
      if (data.verb === 'created') method = 'create'
      if (data.verb === 'updated') method = 'update'
      if (data.verb === 'destroyed') method = 'destroy'
      data = {
        method: method,
        record: data.data
      }
    }
    handleData('partners', theComponent.appSettings.server.host + theComponent.appSettings.server.partnerResource, data)
  }) */

  // ///////////////////////////////////////////////////////////////////////////////////////////////

  return // cb() // теперь cb() вызывается когда все CommonData через mainCommonDataLoader загружены. в первую очередь чтобы отобразить меню, ибо сначала его надо получить с сервера
}



// WEBPACK FOOTER //
// ./src/technical/realtimeServerDataManager.js